export const calculateMarginLevel = (equity: string | null, margin: string) => {
  if (equity === null) {
    return null;
  }
  if (Number(margin) === 0) {
    return 0;
  }

  return (Number(equity) / Number(margin)) * 100;
};
